/* eslint-disable react/self-closing-comp */
import React, { useEffect } from 'react';
import clsx from 'clsx';
import { bool } from 'prop-types';
import Check from 'assets/images/icons/check-icon-2.svg';
import XMark from 'assets/images/icons/xmark.svg';

import styles from './LoaderSpinner.module.scss';

const LoaderSpinner = ({ stop, error }) => {
  useEffect(() => {}, []);

  return (
    <div className={styles.wrapper}>
      <div className={clsx(styles.ring, { [styles.stop]: stop })}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div className={clsx(styles.ringFull, { [styles.stop]: stop })}>
        <div
          className={clsx(styles.check, {
            [styles.stop]: stop,
            [styles.error]: error,
          })}
        >
          {!error && <Check />}
          {error && <XMark />}
        </div>
      </div>
    </div>
  );
};

LoaderSpinner.propTypes = {
  stop: bool.isRequired,
  error: bool,
};

LoaderSpinner.defaultProps = {
  error: false,
};

export default LoaderSpinner;
